<template>
<div class="mainHeader">
<div class="notification">
    <v-btn class="menuBtn" @click.stop="drawer = !drawer" color="primary" icon>
        <v-icon>mdi-menu</v-icon>
     </v-btn>
    <v-btn class="backarrow"  v-if="this.$route.name != 'dashboard'" @click="$router.go(-1)" text>
     <v-icon left>mdi-arrow-left</v-icon>
    </v-btn>
      <v-progress-circular
      v-if="loading"
       :width="3"
        :size="30"
      indeterminate
      class="loadColor"
    >
      <small>{{ value }}</small>
    </v-progress-circular>
</div>
<div class="profile">
    <div class="profileDiv">
        <h4>{{this.User.firstname}} {{this.User.lastname}}</h4>
        <small>Wallet ID: {{this.User.customerID}}</small>
    </div>
    <div>
        <img src="../assets/avatar.png" alt="teller logo" width="70" height="65">
    </div>
</div>
  <v-navigation-drawer
      v-if="drawer"
      v-model="drawer"
      absolute
      temporary
      class="draw"
    >
     <div class="logo">
        <img src="../assets/logo.png" alt="teller logo" width="150" height="40">
    </div>
    <v-list
        class="list"
        nav
        dense
    >
        <v-list-item-group  v-for="(item, i) in items" :key="i" :class="$route.name  === item.route  ? 'highlighted' : 'pointer'"  color="primary">
          <v-list-item @click="navigate(item.route)">
            <v-list-item-icon class="iconX">  
             <v-img v-if="$route.name  != item.route" max-height='30' max-width='30' :src="item.activeIcon" contain></v-img>
             <v-img v-else max-height='30' max-width='30' :src="item.icon" contain></v-img>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title :class="$route.name  === item.route  ? 'highlighted' : 'pointer'">{{item.text}} </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list-item-group>
      </v-list>
    
    <div class="vertical"/>
      <v-list nav
        dense class="list">
           <v-list-item-group   v-for="(item, i) in lasts" :key="i" :class="$route.name  === item.route  ? 'highlighted' : 'pointer'" color="primary">
          <v-list-item @click="navigate(item.route)">
            <v-list-item-icon class="iconX">  
               <v-img v-if="$route.name  != item.route" max-height='30' max-width='30' :src="item.activeIcon" contain></v-img>
             <v-img v-else max-height='30' max-width='30' :src="item.icon" contain></v-img>  
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title :class="$route.name  === item.route  ? 'highlighted' : 'pointer'">{{item.text}}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list-item-group>  
      <div class="list2">
       <Logout/>
      </div>
    </v-list>
    </v-navigation-drawer>
</div>    
</template>
<script>
import currencyFormatter from 'currency-formatter'
import Logout from '../pages/LogOut'
export default {
    components:{Logout},
    data: () => ({
      drawer: false,
      value:0,
      item: 0,
      items: [
        { text: 'Home', icon: require('../assets/iconshome.png'), activeIcon: require('../assets/whome.png'), route: "dashboard" },
        { text: 'Transfer', icon: require('../assets/bx_bx-transfer-alt.png'),activeIcon: require('../assets/wtransfer.png'),route: "transfer"  },
        { text: 'Pay Bills', icon: require('../assets/ri_secure-payment-line.png'),activeIcon: require('../assets/wpayment.png'),route: "paybills"  },
        { text: 'Transaction History', icon: require('../assets/ic_sharp-history.png'),activeIcon: require('../assets/whistory.png'),route: "transactionHistory"  },
      ],
      lasts:[
        { text: 'Change Pin', icon: require('../assets/ri_lock-password-line.png'),activeIcon: require('../assets/wpin.png'),route: "changepin"  },
        { text: 'Customer Services', icon: require('../assets/ri_customer-service-line.png'),activeIcon: require('../assets/customer-service-line.png'),route: "CustomerServices"  },
      ]
    }),
       beforeDestroy () {
      clearInterval(this.interval)
    },
    mounted () {
      this.interval = setInterval(() => {
        if (this.value === 100) {
          return (this.value = 0)
        }
        this.value += 10
      }, 1000)
    }, 
    methods: {
      navigate(to){
        this.$router.push({name: to})
      },
      DisplayCurrency(payload) {
      return currencyFormatter.format(payload, {
        code: "NGN"
      });
    },
    },
  computed: {
       User () {
        return this.$store.getters.getUser
    },

      CommissionBalance () {
        return this.$store.getters.getCommissionBalance
    },
     loading() {
            return this.$store.state.Transactions.loading;
          },
    },
    
}
</script>
<style scoped>
.mainHeader{
    display: flex;
    flex: 1;
    justify-content:space-between;
    align-items: center;
    padding-left: 30px;
    padding-right: 50px;
    height: 100px;

}
.profile{
   display: flex;
    justify-content: flex-end;
    align-items: center; 
}
.profileDiv{
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    margin-right: 15px;
}
.loadColor{
  color:#ad1684
}
.profile h4{
    color: #ad1684;
}
.profile small{
    color: #444444;
}
.menuBtn{
    display: none;
}
.draw{
    background-image: linear-gradient(to bottom, #9f09d7, #bd2427);
}

.sideBar{
  grid-area: sideBar;
  background-image: linear-gradient(to bottom, #9f09d7, #bd2427);
}
.panel{
  grid-area: panel;
   background-color: yellow;

}
.logo{
    margin-left: 20px;
    margin-top: 15px;
    padding: 5px;
    width: 180px;
    border-top-left-radius: 15px;
    border-bottom-right-radius: 15px;
    background-color: white;
}
.balance{
display: flex;
flex-direction: column;
justify-content: center;
height: 70px;
padding-left: 20px;
margin-top: 30px;
margin-bottom: 50px;
background-color: white;   
}
.balance h4{
    color: #ad1684;
}
.card{
    background-color: transparent !important;
    margin-right: 30px !important;
}
.list{
  background-color: transparent !important;  
  margin-left: 10px;
}
.list2{
 margin-top: 150px;
}
.iconX{
   margin-right: 25px;
}
.pointer :hover {
  cursor: pointer;
  border-radius: 5px;
  color:white
}
.highlighted {
  background-color: #fff;
   border-radius: 5px;
}
.maf{
    height: 20px;
    width: 20px;
}

.vertical{
    display: flex;
    flex: 1;
    height: 1px;
    background-color: white;
    margin-left: 30px;
    margin-top: 10px;
    margin-bottom: 10px;

}
.pointer :hover {
  cursor: pointer;
  background-color: rgba(179, 1, 245, 1)!important;
}
.highlighted {
  background-color: #fff !important;
  color: #ad1684;
}
.Logout{
    margin-top: 150px;
    display: flex;
    align-items: flex-end;
}
h4{
  font-family: 'AvenirLTProBook';
  font-size: 18px;
  font-weight: 900;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #ad1684;
}
small{
   font-family: 'AvenirLTProMedium';
  font-size: 14px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #444444;
}

@media only screen and (max-width: 1024px) {

 .menuBtn{
    display: list-item;
}

.mainHeader{
    display: flex;
    flex: 1;
    justify-content:space-between;
    align-items: center;
    padding-left: 10px;
    padding-right: 50px;
    height: 100px;

}

}

</style>